export const USER_SESSIONS = '/sessions' as const
export const USER_SESSION_LOGOUT = '/logout/' as const
export const USER_SESSIONS_LOGOUT_ALL = '/logout/all' as const
